module.exports = __webpack_public_path__ + "img/double-arrow.86296658.svg";